import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCartApi, addToCartApi, updateCartItemApi, removeCartItemApi, clearCartApi } from '../../api/cartApi';

export const fetchCart    = createAsyncThunk('cart/fetch',  async (_, { rejectWithValue }) => {
  try { return (await getCartApi()).data; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const addToCart    = createAsyncThunk('cart/add',    async (data, { rejectWithValue }) => {
  try { await addToCartApi(data); return (await getCartApi()).data; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const updateItem   = createAsyncThunk('cart/update', async ({ id, quantity }, { rejectWithValue }) => {
  try { await updateCartItemApi(id, { quantity }); return (await getCartApi()).data; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const removeItem   = createAsyncThunk('cart/remove', async (id, { rejectWithValue }) => {
  try { await removeCartItemApi(id); return (await getCartApi()).data; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const clearCart    = createAsyncThunk('cart/clear',  async (_, { rejectWithValue }) => {
  try { await clearCartApi(); return { items: [], subtotal: '0.00' }; } catch (e) { return rejectWithValue(e.response?.data?.message); }
});

const cartSlice = createSlice({
  name: 'cart',
  initialState: { items: [], subtotal: '0.00', loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    const fulfilled = (state, { payload }) => { state.loading = false; state.items = payload.items; state.subtotal = payload.subtotal; };
    builder
      .addCase(fetchCart.pending,  (state) => { state.loading = true; })
      .addCase(fetchCart.fulfilled, fulfilled)
      .addCase(addToCart.fulfilled,  fulfilled)
      .addCase(updateItem.fulfilled, fulfilled)
      .addCase(removeItem.fulfilled, fulfilled)
      .addCase(clearCart.fulfilled,  fulfilled);
  },
});

export default cartSlice.reducer;
